"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _svgIcon = require("../SvgIcon");
var _default = (0, _svgIcon).makeIcon("Icon16Done", "done_16", "0 0 16 16", '<symbol viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" id="done_16"><path d="M13.743 3.756a.872.872 0 0 1 0 1.237l-7.317 7.25a.88.88 0 0 1-1.242 0L2.257 9.366a.872.872 0 0 1 0-1.237.88.88 0 0 1 1.242 0l2.306 2.261L12.5 3.756a.88.88 0 0 1 1.242 0Z" fill="currentColor" /></symbol>', 16, 16, false, undefined);
exports.default = _default;
